import { Navigate, Route, Routes } from "react-router-dom";
import { TripLoader } from "@/screens/TripLoader";
import { CreateTripScreen } from "@/screens/CreateTripScreen";
import { SaveLinkStep } from "@/screens/SaveLinkStep";
import { ReceiptsListScreen } from "@/screens/ReceiptsListScreen";
import { ReceiptDetailScreen } from "@/screens/ReceiptDetailScreen";
import { ReceiptUploadScreen } from "@/screens/ReceiptUploadScreen";
import { ManualReceiptCreateScreen } from "@/screens/ManualReceiptCreateScreen";
import { ParticipantsScreen } from "@/screens/ParticipantsScreen";
import { SettleUpScreen } from "@/screens/SettleUpScreen";
import { TripSettingsScreen } from "@/screens/TripSettingsScreen";
import { TripDeletedScreen } from "@/screens/TripDeletedScreen";
import { TripGoneScreen } from "@/screens/TripGoneScreen";
import { NotFoundScreen } from "@/screens/NotFoundScreen";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<CreateTripScreen />} />
      {/* Standalone steps that must NOT fire TripLoader (no tab bar):
          the post-create save-link interstitial and the edge states. */}
      <Route path="/t/:slug/created" element={<SaveLinkStep />} />
      <Route path="/t/:slug/deleted" element={<TripDeletedScreen />} />
      <Route path="/t/:slug/gone" element={<TripGoneScreen />} />

      <Route path="/t/:slug" element={<TripLoader />}>
        {/* No per-trip home (AC-04.9): the index IS the receipts list. */}
        <Route index element={<Navigate to="receipts" replace />} />
        <Route path="receipts" element={<ReceiptsListScreen />} />
        {/* Static `new` outranks the `:rid` dynamic segment in React Router
            v6 ranking, so the manual create screen wins over receipt-detail. */}
        <Route path="receipts/new" element={<ManualReceiptCreateScreen />} />
        <Route path="receipts/:rid" element={<ReceiptDetailScreen />} />
        <Route path="receipts/:rid/upload" element={<ReceiptUploadScreen />} />
        <Route path="participants" element={<ParticipantsScreen />} />
        {/* /balances retired into the single /settle-up surface (ADR-0025);
            redirect keeps any old deep-links alive. */}
        <Route path="balances" element={<Navigate to="../settle-up" replace />} />
        <Route path="settle-up" element={<SettleUpScreen />} />
        <Route path="settings" element={<TripSettingsScreen />} />
      </Route>

      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
}
